import { getToken } from "@/lib/utils";
import { privateRequest, publicRequest } from "../axios";


export const fetchAssessmentsAPI = async (
  search: string = "", 
  pageNo: number = 1, 
  perPage: number = 10, 
  assessmentStatusId?: number
) => {
  try {
    const params: any = { search, pageNo, perPage };
    if (assessmentStatusId) {
      params.statusId = assessmentStatusId;
    }
    const response = await privateRequest.get(`/assessments`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("API Error in fetchAssessmentsAPI:", error);
    throw error;
  }
};

export const fetchAssessmentStatusesAPI = async () => {
  try {
    const response = await privateRequest.get(`/Assessment-status`);
    return response.data;
  } catch (error) {
    console.error("API Error in fetchAssessmentStatusesAPI:", error);
    throw error;
  }
};

export const createAssessmentAPI = async (data: any) => {
  try {
    const response = await privateRequest.post(`/assessments`, data, {
      headers: {
        "Content-Type": "application/json"
      }
    });
    return response.data;
  } catch (error) {
    console.error("API Error in createAssessmentAPI:", error);
    throw error;
  }
};

export const closeAssessmentAPI = async (id: number, assessmentStatusId?: number) => {
  const payload = assessmentStatusId ? { assessmentStatusId } : {};
  const response = await privateRequest.patch(`/assessments/${id}`, payload);
  return response.data;
};

export const deleteAssessmentAPI = async (id: number, assessmentStatusId?: number) => {
  const response = await privateRequest.delete(`/assessments/${id}`, {
    params: assessmentStatusId ? { assessmentStatusId } : undefined
  });
  return response.data;
};

export const getAssessmentByIdAPI = async (id: number) => {
  const response = await privateRequest.get(`/assessments/${id}`);
  return response.data;
};

export const fetchCandidatesAPI = async (
  assessmentId: number, 
  isExport: boolean = false, 
  search: string = "", 
  pageNo: number = 0, 
  perPage: number = 10,
  status?: string,
  cheatingStatus?: string
) => {
  try {
    const params: any = { isExport, search, pageNo, perPage };
    if (status) {
      params.status = status;
    }
    if (cheatingStatus) {
      params.cheatingStatus = cheatingStatus;
    }
    const response = await privateRequest.get(`/assessments/${assessmentId}/candidates`, {
      params,
      responseType: isExport ? 'blob' : 'json'
    });
    return response.data;
  } catch (error) {
    console.error("API Error in fetchCandidatesAPI:", error);
    throw error;
  }
};

export const fetchAssessmentByIdAPI = async (id: number) => {
  try {
    const response = await privateRequest.get(`/assessments/${id}/details`);
    console.log(response);
    
    return response.data;
  } catch (error) {
    console.error("API Error in fetchAssessmentByIdAPI:", error);
    throw error;
  }
};

export const fetchAssessmentDetailsPublicAPI = async (id: number) => {
  try {
    const response = await privateRequest.get(`/assessments/${id}/details`);
    console.log(response);
    
    return response.data;
  } catch (error) {
    console.error("API Error in fetchAssessmentDetailsPublicAPI:", error);
    throw error;
  }
};

export const updateAssessmentAPI = async (id: number, data: any) => {
  try {
    // Some backends require the ID in the body and a specific flag like isPublic
    const payload = { 
      ...data, 
      assessmentId: id,
      isPublic: data.isPublic ?? true 
    };
    
    // We use PATCH but also send X-HTTP-Method-Override just in case the proxy/security blocks PATCH
    const response = await privateRequest.patch(`/assessments/${id}`, payload, {
      headers: {
        "Content-Type": "application/json",
        "X-HTTP-Method-Override": "PATCH"
      }
    });
    // console.log("efgvvvvvvvvvvvvvvvvvvvvvvvv");
    
    return response.data;
  } catch (error) {
    console.error("API Error in updateAssessmentAPI:", error);
    throw error;
  }
};

export const inviteCandidatesAPI = async (assessmentId: number, emails: string[]) => {
  try {
    const response = await privateRequest.post(`/assessments/${assessmentId}/invite`, { emails });
    return response.data;
  } catch (error) {
    console.error("API Error in inviteCandidatesAPI:", error);
    throw error;
  }
};

export const fetchInvitationDetailsAPI = async (token: string) => {
  try {
    const response = await publicRequest.get(`/assessments/invitation/details/${token}`);
    return response.data;
  } catch (error) {
    console.error("API Error in fetchInvitationDetailsAPI:", error);
    throw error;
  }
};

export const beginAssessmentAPI = async (token: string, payload?: { email: string; name?: string; otp?: string }) => {
  try {
    const response = await publicRequest.post(`/assessments/invitation/begin/${token}`, payload);
    console.log("Response from beginAssessmentAPI:", response.data);
    return response.data;
  } catch (error) {
    console.error("API Error in beginAssessmentAPI:", error);
    throw error;
  }
};

export const submitAssessmentAPI = async (assessmentId: number, data: any) => {
  try {
    const response = await privateRequest.post(`/assessments/${assessmentId}/submit`, data, {
      headers: {
        "Content-Type": "application/json"
      }
    });
    return response.data;
  } catch (error) {
    console.error("API Error in submitAssessmentAPI:", error);
    throw error;
  }
};

export const fetchAssessmentSettingsAPI = async (assessmentId: number) => {
  try {
    const response = await privateRequest.get(`/assessment-setting/${assessmentId}`);

    console.log("Raw response from fetchAssessmentSettingsAPI:", response);
    return response.data;
  } catch (error) {
    console.error("API Error in fetchAssessmentSettingsAPI:", error);
    throw error;
  }
};

export const updateAssessmentSettingsAPI = async (assessmentId: number, data: any) => {
  try {
    const response = await privateRequest.patch(`/assessment-setting/${assessmentId}`, data, {
      headers: {
        "Content-Type": "application/json"
      }
    });
    return response.data;
  } catch (error) {
    console.error("API Error in updateAssessmentSettingsAPI:", error);
    throw error;
  }
};

export const fetchCandidateReportAPI = async (assessmentId: number | string, candidateId: number | string) => {
  try {
    const response = await privateRequest.get(`/assessments/${assessmentId}/candidates/${candidateId}/report`);
    return response.data;
  } catch (error) {
    console.error("API Error in fetchCandidateReportAPI:", error);
    throw error;
  }
};

export const downloadCandidateReportAPI = async (assessmentId: number | string, candidateId: number | string) => {
  try {
    const response = await privateRequest.get(`/assessments/${assessmentId}/candidates/${candidateId}/report/download`, {
      responseType: 'blob'
    });
    return response.data;
  } catch (error) {
    console.error("API Error in downloadCandidateReportAPI:", error);
    throw error;
  }
};
